// src/pages/AdminAgendaCitas/utils/parseTime.ts

/**
 * Función para convertir una hora en formato string a un objeto con hora y minutos
 * @param timeString Hora en formato string (HH:MM) o Date
 * @returns Objeto con hora y minutos
 */
export const parseTimeString = (timeString: string | Date | null): { hour: number; minute: number } => {
    if (!timeString) return { hour: 8, minute: 0 };
  
    if (typeof timeString === 'string') {
      const parts = timeString.split(':');
      return {
        hour: parseInt(parts[0], 10) || 0,
        minute: parseInt(parts[1], 10) || 0,
      };
    }
  
    if (timeString instanceof Date) {
      return {
        hour: timeString.getHours(),
        minute: timeString.getMinutes(),
      };
    }
  
    return { hour: 8, minute: 0 };
  };
  
  /**
   * Función para formatear una hora como string HH:MM
   * @param timeValue Hora a formatear
   * @returns String en formato HH:MM
   */
  export const formatTimeToString = (timeValue: string | Date | null): string | null => {
    if (!timeValue) return null;
    
    // Si ya es un string, verificamos su formato
    if (typeof timeValue === 'string') {
      // Si parece una fecha ISO, la convertimos
      if (timeValue.includes('T')) {
        const date = new Date(timeValue);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
      }
      // Si parece un string de tiempo HH:MM:SS, lo limpiamos
      if (timeValue.includes(':')) {
        return timeValue.split(':').slice(0, 2).join(':');
      }
      // De lo contrario, lo devolvemos como está
      return timeValue;
    }
    
    // Si es un objeto Date, lo formateamos
    if (timeValue instanceof Date) {
      const hours = String(timeValue.getHours()).padStart(2, '0');
      const minutes = String(timeValue.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    }
    
    return null;
  };
  
  /**
   * Calcula la hora de fin basada en la hora de inicio y la duración
   * @param startDate Fecha y hora de inicio
   * @param durationMinutes Duración en minutos
   * @returns Fecha y hora de fin
   */
  export const calculateEndTime = (startDate: Date, durationMinutes: number): Date => {
    const endDate = new Date(startDate);
    endDate.setMinutes(endDate.getMinutes() + durationMinutes);
    return endDate;
  };